export const GET_WARNINGS = 'GET_WARNINGS';
export const GET_WARNINGS_SUCCESS = 'GET_WARNINGS_SUCCESS';
export const GET_WARNINGS_ERROR = 'GET_WARNINGS_ERROR';
